"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns true if this is client side
 *
 * @returns true if this is client
 */
const isClient = () => typeof window !== 'undefined';
exports.default = isClient;
//# sourceMappingURL=isClient.js.map